module.exports = __webpack_public_path__ + "static/media/FacebookGames-Dino.a83b43a5.jpg";